export default __webpack_public_path__ + "static/media/MuseoSans_500-webfont.d4cbf41d.woff";